import { FC } from "react";
import { Modal, Row, Col, Divider } from "antd";
import { Button } from "antd";
import { getSchemeDisplayName } from "../../../utils/schemeDisplay";

type CreditNumberModalProps = {
  open: boolean;
  onCancel: () => void;
  emailData: any;
  onYesClicked?: (id: any, data: any) => void | Promise<void>;
};

const CreditNumberModal: FC<CreditNumberModalProps> = ({
  open,
  onCancel,
  emailData,
  onYesClicked,
}) => {
  const handleYesClick = () => {
    if (onYesClicked)
      onYesClicked(emailData?.emailValue?.id, {
        claimId: null,
        creditNumber: emailData?.currentEditValue,
      });
  };

  const renderFieldRow = (label: string, fieldKey: string) => {
    const portalValue =
      fieldKey === "schemeName"
        ? getSchemeDisplayName(emailData?.emailValue)
        : emailData?.emailValue?.[fieldKey];
    const g7Value =
      fieldKey === "schemeName"
        ? getSchemeDisplayName(emailData?.g7Value)
        : emailData?.g7Value?.[fieldKey];

    return (
      <Row
        gutter={16}
        style={{
          background: "#fff",
          padding: "8px 12px",
          borderRadius: 8,
          marginBottom: 10,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        <Col span={8}>
          <strong>{label}</strong>
        </Col>

        <Col span={8}>
          <span>{portalValue || "-"}</span>
        </Col>

        <Col span={8}>
          <span>{g7Value || "-"}</span>
        </Col>
      </Row>
    );
  };

  return (
    <Modal
      title={<div style={{ fontSize: 18, fontWeight: 600 }}>Credit Number</div>}
      open={open}
      footer={null}
      onCancel={onCancel}
      width={850}
      bodyStyle={{ background: "#fafafa", padding: "20px 25px" }}
      style={{
        top: 10,
      }}
    >
      <Row style={{ marginBottom: 10 }}>
        <Col span={8}>
          <strong style={{ color: "rgb(0, 76, 143)" }}>Field</strong>
        </Col>
        <Col span={8}>
          <strong style={{ color: "rgb(0, 76, 143)" }}>Email Details</strong>
        </Col>
        <Col span={8}>
          <strong style={{ color: "rgb(0, 76, 143)" }}>G7 Pro Details</strong>
        </Col>
      </Row>

      {/* {renderFieldRow("Case ID", "caseId")}
      {renderFieldRow("Claim ID", "claimId")}
      {renderFieldRow("DOA", "doa")}
      {renderFieldRow("Health Care ID", "healthCareId")}
      {renderFieldRow("Health Care Name", "healthCareName")}
      {renderFieldRow("Patient Name", "patientName")}
      {renderFieldRow("Scheme ID", "schemeId")}
      {renderFieldRow("Scheme Name", "schemeName")}
      {renderFieldRow("Visit ID", "visitId")} */}
      {renderFieldRow("Beneficiary ID", "beneficiaryId")}
      {renderFieldRow("Card ID", "cardId")}
      {renderFieldRow("Case ID", "caseId")}
      {renderFieldRow("Claim ID", "claimId")}
      {renderFieldRow("Credit Number", "creditNumber")}
      {renderFieldRow("DOA", "doa")}
      {renderFieldRow("Health Care ID", "healthCareId")}
      {renderFieldRow("Health Care Name", "healthCareName")}
      {renderFieldRow("Patient Name", "patientName")}
      {renderFieldRow("Policy Number", "policyNumber")}
      {renderFieldRow("Scheme ID", "schemeId")}
      {renderFieldRow("Scheme Name", "schemeName")}
      {renderFieldRow("Visit ID", "visitId")}

      <Divider />

      <div
        style={{
          gap: 20,
          display: "flex",
          justifyContent: "center",
          marginBottom: 10,
        }}
      >
        <strong style={{ color: "rgb(0, 76, 143)" }}>
          Do you want to attach these details to this email ?
        </strong>
      </div>

      <div
        style={{
          gap: 20,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          type="primary"
          style={{
            backgroundColor: "rgb(0, 76, 143)",
            color: "#fff",
            boxShadow: "0px 2px 8px 0px #00000040",
          }}
          onClick={handleYesClick}
        >
          YES
        </Button>

        <Button onClick={onCancel}>NO</Button>
      </div>
    </Modal>
  );
};

export default CreditNumberModal;
